import React, { useState, useEffect, useCallback } from 'react';
import parse from 'html-react-parser';
import { motion } from 'framer-motion';
import { TContent, TOptions } from '../../utils/types';

interface InputSelectProps {
  contentData: TContent
  answers: TContent[]
  setAnswers: Function
	centered?: boolean
}

const InputSelect = ({ contentData, answers, setAnswers, centered }: InputSelectProps) => {
	const { id, placeholder, textAfter, textBefore, options, default: Default } = contentData;
	const [selected, setSelected] = useState<string | undefined>(Default);
	const [label, setLabel] = useState<string | undefined>(placeholder);
	const [labelStyle, setLabelStyle] = useState<object>({ color: 'rgba(0, 0, 0, 0.3)', fontWeight: '400' });
	const [showOptions, setShowOptions] = useState<boolean>(false);

	const toggleOptions = (e: { preventDefault: () => void }) => {
		setShowOptions(!showOptions);
		e.preventDefault();
	};

	const hideOptions = useCallback((e: any) => {
		if ((e.target as Element).tagName !== 'LI' && (e.target as Element).tagName !== 'SPAN' && (e.target as Element).tagName !== 'BUTTON') {
			setShowOptions(false);
		}
	}, [setShowOptions]);

	const handleSelect = (optionId: string | undefined, value: string | undefined, label: string | undefined) => {
		setSelected(value);
		setLabelStyle({ color: 'rgba(0, 0, 1, 1)', fontWeight: '600' });
		setLabel(label);
		setShowOptions(false);

		const existingAnswers = answers.find((answer) => {
			return answer.inputId === id;
		});

		let newAnswers: any = answers;

		if (existingAnswers) {

			const ix = newAnswers.indexOf(existingAnswers);
			const beforeAnswers = newAnswers.slice(0, ix);

			beforeAnswers.push({
				inputId: id,
				optionId: optionId,
				value: value,
				label: label
			});
			newAnswers = beforeAnswers;
		} else {
			newAnswers = [...newAnswers, { inputId: id, optionId, value: value, label }];
		}

		setAnswers(newAnswers);
	};

	const selectOptions = () => options ? options?.map((option: TOptions) => {
		return (
			<li id={ option.matomoId } key={ option.id } onClick={ () => handleSelect(option.id, option.value, option.label) }>
				{ option.label }
			</li>
		);

	}) : [];

	useEffect(() => {
		if (Default) {
			const defaultOption = options ? options.find((option) => option.value ? option.value === Default : '') : undefined;
			const defaultLabel = defaultOption ? defaultOption.label : undefined;
			const defaultOptionId = defaultOption ? defaultOption.id : undefined;
			setAnswers([...answers, { inputId: id, optionId: defaultOptionId, value: Default, label: defaultLabel }]);
			setLabel(defaultLabel);
		}
	}, [Default, options]);

	useEffect(() => {
		document.addEventListener('click', hideOptions);
		return () => document.removeEventListener('click', hideOptions);
	}, []);

	return (
		<div className={ `input select ${centered ? 'centered' : ''}` }>
			{ textBefore && <span>{ parse(textBefore) }</span> }
			<button id="dropdown_010_dim2" name="dropdown" aria-label="dropdown" value={ selected } onClick={ toggleOptions }>
				<span style={ labelStyle }>{ label }</span>
				<motion.svg
					viewBox="0 0 26 26"
					xmlns="http://www.w3.org/2000/svg"
					animate={ showOptions ? { rotate: '180deg' } : {} }
					transition={ { duration: 0.15, ease: 'easeIn' } }
				>
					<circle cx="13" cy="13" r="13" />
					<path d="M17.3362 11.8073L12.9589 16.1846L8.58153 11.8073" stroke="white" strokeWidth="2" />
				</motion.svg>
				<div className="select-container">
					<ul>
						{ showOptions && selectOptions() }
					</ul>
				</div>
			</button>
			{ textAfter && <span>{ parse(textAfter) }</span> }
		</div>
	);
};

export default InputSelect;